import { makeVar } from '@apollo/client';

import { FeatureFlagMap } from '@/modules/featureFlags/featureFlags.types';
import { EstateWaterfall, User } from '@/types/schema';

export const mostRecentlyViewedWaterfallVar =
  makeVar<User['localMostRecentlyViewedWaterfall']>(null);

export const mostRecentlyViewedEntityMapVar =
  makeVar<User['localMostRecentlyViewedEntityMap']>(null);

export const mostRecentlyViewedHouseholdsVar = makeVar<
  { id: string; displayName: string; private?: boolean }[]
>([]);

export const deletedHouseholdIdsVar = makeVar<string[]>([]);
export const deletedEntityIdsVar = makeVar<string[]>([]);

export const showWaterfallSummaryTileDetailsVar = makeVar<
  EstateWaterfall['localShowSummaryTileDetails'] | null
>(null);

export const featureFlagsVar = makeVar<FeatureFlagMap>({});
// True after the feature-flag request completes or fails. An empty
// featureFlagsVar does not tell if the flags are still loading.
export const featureFlagsLoadedVar = makeVar(false);

export const snowflakeIntegrationDisplayNameVar = makeVar<string | null>(null);

// Tracks notification status for the most recently created hypothetical GRAT
export type NewHypotheticalItemNotification =
  | {
      entityId: string;
      dismissed: boolean;
    }
  | {
      proposalId: string;
      dismissed: boolean;
    };

export const newHypotheticalItemNotificationVar =
  makeVar<NewHypotheticalItemNotification | null>(null);
